export default () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <s-spinner accessibilityLabel="Loading content" size="large-100" />
    </div>
  );
};
